// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module--content--1mZd7","title":"styles-module--title--2pcik","header":"styles-module--header--1UBAQ","blurb":"styles-module--blurb--1lSoF"};